export default "__VITE_ASSET__Cjy8dNzz__"